<template>
  <MasterDetail
    ref="table"
    :cols="cols"
    :contextOptions="options"
    :customResource="customResource"
    :formTitle="formTitle"
    :opts="opts"
    @onOpenFormDialog="onOpenFormDialog"
  ></MasterDetail>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import { isEmpty } from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {
    MasterDetail
  },
  computed: {
    ...mapGetters(["clientId"]),
    cols() {
      const updateValorBase = encargoPadraoId => {
        const found = this.opts.encargosPadrao.find(
          ({ id }) => id === encargoPadraoId
        );
        this.$refs.table.selectedItem.valor_base = found?.valor_base ?? "";
      };

      return [
        { key: "id", name: "ID", hideInform: true },        
        {
          key: "nome",
          name: "Nome",
          type: this.$fieldTypes.TEXT,
          colSize: 12
        },
        {
          key: "grupo_display",
          name: "Grupo",
          type: this.$fieldTypes.TEXT,
          hideInform: true
        },
        {
          key: "encargo_padrao_id",
          name: "Grupo",
          type: this.$fieldTypes.SELECT,
          rel: { to: "encargosPadrao", key: "id", name: "nome" },
          rules: [{ rule: "required" }],
          colSize: 12,
          hideInTable: true,
          valueChanged: updateValorBase
        },
        {
          key: "unidade",
          name: "Unidade",
          type: this.$fieldTypes.SELECT,
          rel: { to: "unidades", key: "id", name: "nome" },
          rules: [{ rule: "required" }],
          colSize: 6
        },
        {
          key: "valor_base",
          name: "Valor base",
          type: this.$fieldTypes.TEXT,
          hideInTable: true,
          editable: false,
          colSize: 6
        },
        {
          key: "criado_em",
          name: "Criado Em",
          type: this.$fieldTypes.DATETIME,
          hideInform: true
        },
        {
          key: "modificado_em",
          name: "Modificado Em",
          type: this.$fieldTypes.DATETIME,
          hideInform: true
        }
      ];
    },
    customResource() {
      const resource = this.apiResource(
        `/v1/rh/clientes/${this.clientId}/grupoEncargos`
      );

      return {
        ...resource,
        async get(...args) {
          try {
            const response = await resource.get(...args);
            return response.map(({ encargo_padrao, grupo, nome, ...rest }) => ({
              ...rest,
              encargo_padrao,
              grupo,
              nome,
              grupo_display: encargo_padrao?.nome ?? grupo ?? "Sem nome",
              valor_base: encargo_padrao?.valor_base ?? "Sem valor base"
            }));
          } catch (error) {
            if (!error.isAxiosError) {
              this.notify(error);
            }
          }
        },
        async save(obj, id) {
          const payload = { ...obj, nome: obj.nome ?? "" };
          return resource.save(payload, id);
        }
      };
    },
    options() {
      return [
        {
          name: "Ver Encargos",
          limit: 1,
          class: { "btn-info": true, "btn-md": true },
          cb: grupo => {
            this.$router.push({
              name: "dispendio-encargos-previdenciarios-detalhes",
              params: { grupoId: grupo.id }
            });
          }
        }
      ];
    }
  },
  created() {
    if (!this.clientId) {
      this.goHome();
    }
  },
  data() {
    return {
      formTitle: "",
      opts: {
        encargosPadrao: [],
        unidades: [
          { id: 1, nome: "Matriz" },
          { id: 0, nome: "Filial" }
        ]
      }
    };
  },
  watch: {
    clientId(value) {
      if (!value) {
        this.goHome();
      }
    }
  },
  methods: {
    async getEncargosPadrao() {
      try {
        const response = await this.apiResource(`/v1/rh/encargosPadrao`).get();
        this.opts.encargosPadrao = response.sort(
          ({ nome: nomeA }, { nome: nomeB }) => nomeA.localeCompare(nomeB)
        );
      } catch (error) {
        this.opts.encargosPadrao = [];

        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    },
    goHome() {
      this.$router.push({
        name: "homepage"
      });
    },
    onOpenFormDialog(selectedItem) {
      const target = selectedItem ?? {};
      const prefix = isEmpty(target) ? "Cadastro" : "Edição";
      this.formTitle = `${prefix} Grupo Encargos Previdenciários`;

      if (this.opts.encargosPadrao.length === 0) {
        this.getEncargosPadrao();
      }
    }
  }
};
</script>
